<template>
  <section>
    <header-portal></header-portal>
    <template>
      <v-stepper v-model="e13" vertical>
        <v-stepper-step :complete="e13 > 1" step="1" :editable="e13 !==3" @click="crearImagenCaptcha(), clearLoaders()">
          <h4><v-icon color="primary">person</v-icon> Datos Personales</h4>
        </v-stepper-step>
        <v-stepper-content step="1">
          <!-- inicio de paso 1 -->
            <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card v-if="form.tipdoc_codigo === '1'" class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Los datos en esta sección se contrastarán con <strong>SEGIP</strong> por favor verifique sus datos.</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
          <v-alert v-if="form.tipdoc_codigo === '1'"
          class="decretos"
            color="info"
            :value="true" >
            <div class="text-xs-justify">
              <p><v-icon>info</v-icon> Los datos en esta sección se contrastaran con <strong>SEGIP</strong> porfavor verifique sus datos.</p>
            </div>
          </v-alert>
          <v-card>
            <!-- <v-card-title><h4> Datos Personales</h4></v-card-title> -->
            <v-card-text>
              <v-form v-model='valid' ref='formPersonales' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model="form.tipdoc_codigo"
                          :items="itemsTipoDocumentoIdentidad"
                          item-text='tipo_documento'
                          item-value='tipo_documento_codigo'
                          label='Tipo de Documento*'
                          :rules='dRules'
                          required
                          prepend-icon="credit_card"
                        ></v-select>
                      </v-flex>
                      <v-flex md6 xs12 v-if="form.tipdoc_codigo === '1'">
                        <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='tipoNacionalidad'
                          :items='itemsTipoNacionalidad'
                          item-text='tipoNacionalidad_descripcion'
                          item-value='tipoNacionalidad_codigo'
                          label='Nacionalidad*'
                          :rules='dRules'
                          required
                          persistent-hint
                          prepend-icon="public"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="form.tipdoc_codigo === '1'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md8 xs12>
                       <v-text-field
                         v-model="form.numero_docidentidad"
                         label='Número de Cédula de Identidad*'
                         maxlength='9'
                         :rules='ciRules'
                         required
                         prepend-icon="fingerprint"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="form.sufijo_docidentidad"
                          label='Complemento SEGIP'
                          maxlength='2'
                          :rules='complementoRules'
                          prepend-icon="fingerprint"
                          class="text-normal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="form.tipdoc_codigo === '3'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="form.prefijo_docidentidad"
                          label='Prefijo Pasaporte'
                          :rules="textAreaRules"
                          maxlength='5'
                          prepend-icon="keyboard_arrow_left"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                         v-model="form.numero_docidentidad"
                         label='Valor Númerico de Pasaporte*'
                         maxlength='9'
                         :rules='ciRules'
                         required
                         prepend-icon="fingerprint"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="form.sufijo_docidentidad"
                          label='Sufijo Pasaporte'
                          maxlength='5'
                          :rules="textAreaRules"
                          prepend-icon="keyboard_arrow_right"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-text-field
                         v-model="form.perdec_appaterno"
                         label='Apellido Paterno'
                         maxlength='100'
						             :rules="textAreaRules"
                         prepend-icon="edit"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="form.perdec_apmaterno"
                          label='Apellido Materno'
                          maxlength='100'
						              :rules="textAreaRules"
                          prepend-icon="edit"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      v-model="form.perdec_nombres"
                      label='Nombres*'
                      maxlength='100'
                      required
					            :rules="textRules"
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='form.perdec_genero'
                          :items='itemsGenero'
                          item-text='tipo_genero'
                          item-value='tipo_genero_codigo'
                          label='Género'
                          :rules='dRules'
                          required
                          persistent-hint
                          prepend-icon="wc"
                        ></v-select>
                      </v-flex>
                      <v-flex md6 xs12>
                        <global-date-input-picker
                          v-model="date" :hint="'Formato DD/MM/AAAA'" :rules="dateRules" label="Fecha de Nacimiento*">
                        </global-date-input-picker> 
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                  <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
                <h4>Digite las letras y/o números que aparecen en la Imagen </h4>
                <v-layout row wrap>
                  <v-flex md3 offset-md1>
                    <img
                      :src="imgb64"
                      alt="Bolivia">
                  </v-flex>
                  <v-flex md3 offset-md1>
                    <v-text-field
                      v-model="form.captcha"
                      :rules='this.useCaptcha ? dRules : []'
                      label='Respuesta'
                      :required="this.useCaptcha"
                      :maxlength="this.lengthCaptcha"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md1>
                    <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="verificarDatos(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton">
                <v-icon>navigate_next</v-icon>&nbsp;Siguiente
                <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
              </v-btn>
              <v-btn
                color="error"
                :disabled="buttonCancel"
                @click="$router.push('/')">
                <v-icon>cancel</v-icon>&nbsp;Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 1 -->
        </v-stepper-content>

        <v-stepper-step  :complete="e13 > 2" step="2" :editable='false'>
          <h4><v-icon color="primary">account_circle</v-icon>  Datos Adicionales. </h4>
        </v-stepper-step>
        <v-stepper-content step="2">
          <!-- inicio de paso 2 -->
          <v-card>
            <v-card-text>
              <div v-if="this.verificaRegistro === '200'">
              <v-form v-model='valid' ref='formAdi' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                     <v-alert :value='true' type='info' outline>
                       Favor añada sus Datos de Contacto
                     </v-alert>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-text-field
                          class="text-normal"
                          v-model="form.correo1"
                          :rules='!this.correoOk ? dRulesCorreo : []'
                          :required="!this.correoOk"
                          label='Correo Electrónico Personal'
                          prepend-icon="email"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="form.cuefundec_telefono_celular"
                          label='Número de Celular Personal*'
                          :rules='celularRules'
                          required
                          prepend-icon="phone"
                          maxlength='8'
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                </v-form>
              </div>
              <div v-if="this.verificaRegistro === '100'">
                <v-form v-model='valid' ref='formControl' lazy-validation>
                  <v-layout row wrap>
                  <v-flex md6 offset-md2>
                      <div class="decretosBoton">
                      <v-menu bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small tile outline color="primary">
                      <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                      </v-btn>
                  </template>
                  <v-card class="px-2 py-1">
                    <v-card-text class="black--text body-2">
                      <v-icon small color="info">info</v-icon>&nbsp;
                      <span>Ya existe una cuenta o tarjeta con los datos personales digitados, 
                          por favor registre su última Declaración Jurada de Bienes y Rentas</span>
                    </v-card-text>
                  </v-card>
                </v-menu>
                    </div>
                     <v-alert class="decretos" :value='true' type='info' outline>Ya existe una cuenta o tarjeta con los datos personales digitados, 
                       por favor registre su última Declaración Jurada de Bienes y Rentas
                     </v-alert>
                  </v-flex>
                  </v-layout>
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="form.control_cge"
                      label='Código de Control CGE de su última Declaración Jurada de Bienes y Rentas*'
                      maxlength='15'
                      :rules='dRules'
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                </v-form>
              </div>
                <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="loadingButton"
                :disabled="loadingButton"
                @click="verificarAdi()">
                <v-icon>navigate_next</v-icon>&nbsp;Siguiente
                <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 2 -->
        </v-stepper-content>

        <v-stepper-step  :complete="e13 > 3" step="3" :editable='false'>
          <h4><v-icon color="primary">credit_card</v-icon>  Digite los Datos de la Tarjeta. </h4>
        </v-stepper-step>
        <v-stepper-content step="3">
          <!-- inicio de paso 3 -->
          <v-card>
            <v-card-text>
              <v-form v-model='valid' ref='formTarjeta' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <p>Código de la tarjeta*</p>
                    <v-layout>
                      <v-flex md4>
                       <v-text-field
                         v-model="codigoTarjeta.primero"
                         :rules='tarjetaRules'
                         requid
                         maxlength=4
                         prepend-icon="credit_card"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="codigoTarjeta.segundo"
                          :rules='tarjetaRules'
                         requid
                          maxlength=4
                          prepend-icon="remove"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          v-model="codigoTarjeta.tercero"
                          :rules='tarjetaRules'
                          requid
                          maxlength=4
                          prepend-icon="remove"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="form.tar_pin_tarjeta"
                      :rules='dRulesPin'
                      label='Número Pin*'
                      maxlength=6
                      required
                      type='password'
                      prepend-icon="fiber_pin"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
                <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="loadingButton"
                :disabled="loadingButton"
                @click="crearCuenta()">
                <v-icon>navigate_next</v-icon>&nbsp;Siguiente
                <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 3 -->
        </v-stepper-content>

        <v-stepper-step  :complete="e13 > 4" step="4" :editable='false'>
          <h4><v-icon color="primary">done_all</v-icon> Tarjeta Activada</h4>
        </v-stepper-step>
        <v-stepper-content step="4">
          <!-- inicio de paso 4 -->
          <v-card>
            <div ref="pdf">
            <v-card-text>
                <div class="decretosBoton">
                  <v-menu bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small tile outline color="primary">
                  <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                  </v-btn>
              </template>
              <v-card class="px-2 py-1">
                <v-card-text class="black--text body-2">
                  <v-icon small color="info">info</v-icon>&nbsp;
                  <span>Tome nota de la tarjeta que se activó para ingresar al sistema.</span>
                </v-card-text>
              </v-card>
            </v-menu>
                </div>
              <v-alert
              class="decretos"
                color="info"
                :value="true" >
                <div class="text-xs-justify">
                  <h4>Tome nota de la tarjeta que se activó para ingresar al sistema.</h4>
                </div>
              </v-alert>
              Se creo activó la tarjeta:
              <v-layout wrap>
                <v-flex md4 offset-md4>
                  <h3><strong>{{ this.form.tar_codigo_tarjeta.toUpperCase() }}</strong></h3>
                </v-flex>
              </v-layout>
              <p>Con los siguientes datos personales:</p><br/>
              <v-layout wrap>
                <v-flex xs6 md3>
                  Documento de Identificación
                  <p><strong>{{ this.form.tipdoc_codigo === '1' ? this.itemsTipoDocumentoIdentidad[0].tipo_documento : this.form.tipdoc_codigo === '3' ? this.itemsTipoDocumentoIdentidad[1].tipo_documento :  '' }}</strong></p>
                </v-flex>
                <v-flex xs6 md3>
                  Número de Documento
                  <p><strong>{{ this.form.numero_docidentidad }}</strong></p>
                </v-flex>
                <v-flex xs6 md3>
                  Fecha de Nacimiento
                  <p><strong>{{ this.date }}</strong></p>
                </v-flex>
                <v-flex xs6 md3>
                  Género
                  <p><strong>{{ this.form.perdec_genero !== '' ? this.itemsGenero[parseInt(this.form.perdec_genero)].tipo_genero : '' }}</strong></p>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 md4>
                  Apellido Paterno
                  <p><strong>{{ this.form.perdec_appaterno.toUpperCase() }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Apellido Materno
                  <p><strong>{{ this.form.perdec_apmaterno.toUpperCase() }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Nombres
                  <p><strong>{{ this.form.perdec_nombres.toUpperCase() }}</strong></p>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 md4>
                  Dirección de Correo Electrónico Personal
                  <p><strong>{{ this.form.correo1 }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Número de Celular Personal
                  <p><strong>{{ this.form.cuefundec_telefono_celular }}</strong></p>
                </v-flex>
              </v-layout>
            </v-card-text>
            </div>
            <p>Imprima esta página y apersonese a la CGE a efectos de corregir los datos en caso de encontrar algo incorrecto</p>
            <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn color="primary" @click="generarPDF()"><v-icon>print</v-icon>&nbsp;Imprimir Activación Tarjeta</v-btn>
               <v-btn color="error" @click="$router.push('/')"><v-icon>done_all</v-icon>&nbsp;Terminar</v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 4 -->
        </v-stepper-content>
      </v-stepper>
    </template>
  </section>
</template>
<script>
// import Jspdf from 'jspdf';
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import Segip from '../mixins/segip.js';
import Cuentas from '../mixins/cuentas.js';
import Captcha from '../mixins/captcha.js';
let sha256 = require('sha256');

export default {
  mixins: [ Segip, Cuentas, Captcha ],
  components: {
    HeaderPortal
  },
  created () {
    this.crearImagenCaptcha();
  },
  data: () => ({
    sha256DatosSegip: '',
    e13: 1,
    valid: true,
    dialogVisible: false,
    tipoNacionalidad: '1',
    codigoTarjeta: {
      primero: '',
      segundo: '',
      tercero: ''
    },
    form: {
      prefijo_docidentidad: '',
      numero_docidentidad: '',
      sufijo_docidentidad: '',
      tipdoc_codigo: '1',
      perdec_appaterno: '',
      perdec_apmaterno: '',
      perdec_nombres: '',
      tar_codigo_tarjeta: '',
      tar_pin_tarjeta: '',
      perdec_genero: '',
      cuefundec_telefono_celular: '',
      correo1: '',
      captcha: '',
      control_cge: null,
      perdec_codigo: null
    },
    itemsTipoDocumentoIdentidad: [
      {
        tipo_documento: 'Cédula de Identidad',
        tipo_documento_codigo: '1'
      },
      {
        tipo_documento: 'Pasaporte',
        tipo_documento_codigo: '3'
      }
    ],
    itemsTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'Nacional',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'Extranjero',
        tipoNacionalidad_codigo: '2'
      }
    ],
    itemsGenero: [
      {
        tipo_genero: 'FEMENINO',
        tipo_genero_codigo: '0'
      },
      {
        tipo_genero: 'MASCULINO',
        tipo_genero_codigo: '1'
      }
    ],
    verificaRegistro: '',
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    loader: null,
    loadingButton: false,
    buttonCancel: false,
    correoOk: false,
    menu: false,
    date: '',
    dRules: [v => !!v || 'Este campo es requerido'],
    dRulesPin: [v => v > 0 || 'Solo números son permitidos'],
    tarjetaRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-]+$/.test(v) || 'Carácter no permitido'],
    dRulesCorreo: [],
    textAreaRules: [v => v === '' ? true : /^[a-zA-Z0-9-_/.*'(),.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*'()"“”,.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    dateRules: [v => !!v || 'Este campo es requerido',
      v => (v && v.length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos',
      v => (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    ciRules: [
      v => !!v || 'El número de Documento es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de Documento no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    celularRules: [
      v => (v && v.length <= 8) || 'Este campo es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de celular no es válido'
    ],
    perdec_codigo: ''
  }),
  methods: {
    async crearImagenCaptcha () {
      this.form.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    generarPDF () {
      this.$service.get(`reporte/jasper_crea_cuenta`).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(this.b64toBlob(response, 'application/pdf'));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `ACTIVACION_TARJETA.pdf`);
          document.body.appendChild(link);
          link.click();
          this.$storage.remove('token');
        }
      }).catch(err => {
        console.log(err);
        this.$storage.remove('token');
      });
    },
    async verificarDatos () {
      if (this.form.sufijo_docidentidad === 'lp' || this.form.sufijo_docidentidad === 'cb' || this.form.sufijo_docidentidad === 'sc' ||
          this.form.sufijo_docidentidad === 'pt' || this.form.sufijo_docidentidad === 'or' || this.form.sufijo_docidentidad === 'ch' ||
          this.form.sufijo_docidentidad === 'tj' || this.form.sufijo_docidentidad === 'bn' || this.form.sufijo_docidentidad === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.form.sufijo_docidentidad = '';
      }
      if (!(!!this.form.perdec_apmaterno || !!this.form.perdec_appaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.formPersonales.validate() && (!!this.form.perdec_apmaterno || !!this.form.perdec_appaterno)) {
        this.loadingButton = true;
        this.buttonCancel = true;
        if (this.form.tipdoc_codigo === '1') {
          // let params = {
          //   tipo_persona: this.tipoNacionalidad,
          //   NumeroDocumento: this.form.numero_docidentidad,
          //   PrimerApellido: this.form.perdec_appaterno,
          //   SegundoApellido: this.form.perdec_apmaterno,
          //   nombres: this.form.perdec_nombres,
          //   token: this.tokenCaptcha,
          //   captcha: this.form.captcha
          // };
          // if (this.form.sufijo_docidentidad !== '') {
          //   params.NumeroDocumento = `${this.form.numero_docidentidad}-${this.form.sufijo_docidentidad}`;
          // }
          // let responseSegip = await this.contrastarSegip(params).then(resp => {
          //   if (resp.err_existente === 0) {
          //     this.$message['success'](resp.err_mensaje);
          //     resp.finalizado = true;
          //   }
          //   if (resp.err_existente === 1) {
          //     this.$message['info'](resp.err_mensaje);
          //     resp.finalizado = false;
          //   }
          //   if (resp.error_codigo === 503) {
          //     this.$message['info']('El servicio de contrastación no está disponible, se continuará sin esta verificación.', 'SEGIP', {timeout: 15000});
          //     resp.finalizado = true;
          //   }
          //   return resp;
          // }).catch(e => {
          //   console.log(e);
          //   this.loadingButton = false;
          //   return e;
          // });
          // this.segipContrastacion = responseSegip.camposComparados;
          // let estadoSegip = responseSegip.estadoSegip ? responseSegip.estadoSegip : true;
          // if (responseSegip.finalizado === true) {
          let paramsVerificar = {
            prefijo_docidentidad: this.form.prefijo_docidentidad,
            numero_docidentidad: this.form.numero_docidentidad,
            sufijo_docidentidad: this.form.sufijo_docidentidad,
            tipdoc_codigo: this.form.tipdoc_codigo,
            perdec_fecha_nacimiento: this.date,
            perdec_appaterno: this.form.perdec_appaterno,
            perdec_apmaterno: this.form.perdec_apmaterno,
            perdec_nombres: this.form.perdec_nombres
          };
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service.post(`control_tarjeta/verifica_datos_personales`, paramsVerificar).then(response => {
            this.$storage.remove('token');
            if (response) {
              this.sha256DatosSegip = sha256(JSON.stringify(this.form));
              this.e13 = 2;
              this.verificaRegistro = response.inf_complemento;
              this.form.perdec_codigo = response.inf_codigo;
              this.loadingButton = false;
              this.buttonCancel = false;
            } else {
              this.loadingButton = false;
              this.buttonCancel = false;
            }
          }).catch(error => {
            this.$storage.remove('token');
            console.log(error);
            this.loadingButton = false;
            this.buttonCancel = false;
          });
          this.$storage.remove('token');
          // } else {
          //   this.loadingButton = false;
          //   this.buttonCancel = false;
          //   this.crearImagenCaptcha();
          //   responseSegip.mensaje.forEach(msj => {
          //     this.$message[responseSegip.tipo](msj);
          //   });
          // }
        }
        if (this.form.tipdoc_codigo === '3') {
          let paramsVerificar = {
            prefijo_docidentidad: this.form.prefijo_docidentidad,
            numero_docidentidad: this.form.numero_docidentidad,
            sufijo_docidentidad: this.form.sufijo_docidentidad,
            tipdoc_codigo: this.form.tipdoc_codigo,
            perdec_fecha_nacimiento: this.date,
            perdec_appaterno: this.form.perdec_appaterno,
            perdec_apmaterno: this.form.perdec_apmaterno,
            perdec_nombres: this.form.perdec_nombres
          };
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service
          .post(`control_tarjeta/verifica_datos_personales`, paramsVerificar)
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.sha256DatosSegip = sha256(JSON.stringify(this.form));
              this.e13 = 2;
              this.verificaRegistro = response.inf_complemento;
              this.form.perdec_codigo = response.inf_codigo;
              this.loadingButton = false;
              this.buttonCancel = false;
            } else {
              this.loadingButton = false;
              this.buttonCancel = false;
            }
          }).catch(error => {
            this.$storage.remove('token');
            console.log(error);
            this.loadingButton = false;
            this.buttonCancel = false;
          });
          this.$storage.remove('token');
        }
      } else {
        this.loader = null;
        this.loadingButton = false;
        this.buttonCancel = false;
        this.$message['warning']('Verificación Incorrecta, Datos requeridos incompletos.');
      }
    },
    verificarAdi () {
      if (this.verificaRegistro === '200') {
        if (this.$refs.formAdi.validate()) {
          this.loadingButton = true;
          let paramsVerificar = {
            cuefundec_telefono_celular: this.form.cuefundec_telefono_celular,
            correo1: this.form.correo1
          };
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service
          .post(`control_tarjeta/verifica_datos_complementarios`, paramsVerificar)
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.$message['success'](response.err_mensaje);
              this.e13 = 3;
              this.loadingButton = false;
            } else {
              this.loadingButton = false;
            }
          }).catch(error => {
            this.$storage.remove('token');
            console.log(error);
            this.loadingButton = false;
          });
          this.$storage.remove('token');
        } else {
          this.loadingButton = false;
          this.$message['warning']('Verificación Incorrecta, Datos requeridos incompletos.');
        }
      }
      if (this.verificaRegistro === '100') {
        if (this.$refs.formControl.validate()) {
          this.loadingButton = true;
          let paramsVerificar = {
            control_cge: this.form.control_cge,
            perdec_codigo: this.form.perdec_codigo
          };
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service
          .post(`control_tarjeta/verifica_datos_complementarios`, paramsVerificar)
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.$message['success'](response.err_mensaje);
              this.e13 = 3;
              this.loadingButton = false;
            } else {
              this.loadingButton = false;
            }
          }).catch(error => {
            this.$storage.remove('token');
            console.log(error);
            this.loadingButton = false;
          });
          this.$storage.remove('token');
        } else {
          this.loadingButton = false;
          this.$message['warning']('Verificación Incorrecta, Datos requeridos incompletos.');
        }
      }
    },
    async crearCuenta () {
      if (this.$refs.formTarjeta.validate()) {
        this.loadingButton = true;
        this.form.tar_codigo_tarjeta = `${this.codigoTarjeta.primero}${this.codigoTarjeta.segundo}${this.codigoTarjeta.tercero}`;
        let params = {
          tar_codigo_tarjeta: this.form.tar_codigo_tarjeta,
          tar_pin_tarjeta: this.form.tar_pin_tarjeta
        };
        let responseCuenta = await this.verificarTarjeta(params).then(resp => {
          if (resp.error_existente === 1) {
            this.loadingButton = false;
          }
          return resp;
        }).catch(error => {
          console.log(error);
          this.loadingButton = false;
        });
        if (this.form.perdec_codigo === '') {
          this.form.perdec_codigo = null;
        }
        if (responseCuenta) {
          if (responseCuenta.finalizado) {
            this.$storage.set('token', process.env.TOKEN_EXTERNO);
            this.form.perdec_fecha_nacimiento = this.date;
            this.$service
            .post(`control_tarjeta/cuenta_tarjeta`, this.form)
            .then(response => {
              this.$storage.remove('token');
              if (response) {
                this.$storage.set('token', response.token);
                this.perdec_codigo = response.inf_codigo;
                this.$message['success'](response.err_mensaje);
                this.e13 = 4;
                this.loadingButton = false;
              } else {
                this.loadingButton = false;
              }
            }).catch(error => {
              this.$storage.remove('token');
              console.log(error);
              this.loadingButton = false;
            });
            this.$storage.remove('token');
          } else {
            this.codigoTarjeta.primero = '';
            this.codigoTarjeta.segundo = '';
            this.codigoTarjeta.tercero = '';
            this.form.tar_pin_tarjeta = '';
            this.loadingButton = false;
          }
        }
      }
    },
    clearLoaders () {
      this.loader = null;
      this.loadingButton = false;
      this.buttonCancel = false;
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  },
  watch: {
    'form.correo1' (val) {
      if (this.form.correo1 !== '' || this.form.correo1 !== null) {
        this.correoOk = this.form.correo1 === '' || this.form.correo1 === null ? true : this.validarCorreo(this.form.correo1);
        this.dRulesCorreo = [v => this.correoOk || 'El correo no tiene el formato correcto'];
      } else {
        this.correoOk = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import '../../admin/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/components/portal/login/ActivarTarjeta.vue